<button class="btn btn-close btn-close-attachment" (click)="closeDialog()">
    <ihd-icon name="close" class="mod-sm"></ihd-icon>
</button>
<ihd-dialog-body class="ihd-dialog-body">
    <img [src]="config.url">
</ihd-dialog-body>
<ihd-dialog-actions class="ihd-dialog-actions">
    <button class="btn btn-link btn-attachment btn-lg" (click)="saveAttachment($event)">
        {{'Common.SaveAttachment'|translate}}
    </button>
</ihd-dialog-actions>
